export class Template {
    constructor({
                    id = null,
                    template = '',
                    company_id = null,
                    list_id = null,
                    name = '',
                    isStandardTemplate = null,
                    subject = ''
                } = {}) {
        this.id = id;
        this.template = template;
        this.company_id = company_id;
        this.list_id = list_id;
        this.name = name;
        this.isStandardTemplate = isStandardTemplate;
        this.subject = subject;
    }
}

export function createTemplate(data={}) {
    return Object.freeze(new Template(data));
}